let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l3bUA")).then(() => parcelRequire('48H1x'));